import { render } from "./LabelModal.vue?vue&type=template&id=4198a170"
import script from "./LabelModal.vue?vue&type=script&lang=js"
export * from "./LabelModal.vue?vue&type=script&lang=js"

import "./LabelModal.vue?vue&type=style&index=0&id=4198a170&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__